export const openChatWidget = () => {
  if((window as any).drift) {
    (window as any).drift.api.openChat();
  }
  if((window as any).Trengo) {
    (window as any).Trengo.Api.Widget.open('chat');
  }
}
